import React, { useRef } from 'react';
import BundledEditor from 'common/BundledEditor'
import { Form, Button } from 'react-bootstrap';

export default function BoardWrite({ upload, post }) {
    const [title, setTitle] = React.useState('')
    const [contents, setContents] = React.useState('')
    const editorRef = useRef(null);

    React.useEffect(() => {
        if (post) {
            console.log(post)
            setTitle(post.title)
            setContents(post.contents)
            // if (editorRef)
            //     editorRef.current.setContent(post.content)
        }
    }, [post])

    // function setContents(editor) {
    //     console.log(editor)
    //     console.log(editor.getContent)
    //     console.log(editor.setContent)
    //     editor.setContent(post.contents)
    // }

    return (
        <div className="m-3">
            <Form.Control className="my-3 mb-1" type="text" placeholder="제목" value={title} onChange={(e) => { setTitle(e.target.value) }} />
            <BundledEditor
                onInit={(evt, editor) => { return editorRef.current = editor }}
                initialValue={contents}
                init={{
                    height: 500,
                    menubar: false,
                    plugins: [
                        'advlist', 'anchor', 'autolink', 'help', 'image', 'link', 'lists',
                        'searchreplace', 'table', 'wordcount'
                    ],
                    toolbar: 'undo redo | blocks | ' +
                        'bold italic forecolor | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | ' +
                        'removeformat | help',
                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                }}
            />
            <div className="d-flex" style={{ justifyContent: "end" }}>
                <Button variant="outline-secondary" onClick={() => { post ? upload(title, editorRef.current.getContent(), post.id) : upload(title, editorRef.current.getContent()) }} className="m-2 " style={{ borderColor: "#bcbcbc" }}>
                    {post ? "수정" : "업로드"}
                </Button>
            </div>
        </div>
    );
}